export default __webpack_public_path__ + "static/media/photo--lg--misc-3.2575a13c.jpg";